module.exports = __webpack_public_path__ + "media/application/images/icons/united-kingdom-2c05d3d7459b196843aaf094fd78e769.svg";